import React from "react";
import { useSelector } from "react-redux";
import Support from "logistic-integrations/components/Support";
import { useTranslation } from "react-i18next";

function JeeblySupport() {
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const { t } = useTranslation();
  return (
    <Support
      orderNo={
        orderInfo?.logisticPartnerMetadata?.JEEBLY?.createDeliveryResponse
          ?.['Order Id']
      }
      phone="+971600533259"
      heading={t("Jeebly Order Number")}
      heading2={t("Jeebly Helpline Number")}
    />
  );
}

export default JeeblySupport;
